function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "youtube",
  d: "M19.217-3.932a2.458,2.458,0,0,0-1.729-1.73c-1.535-.42-7.677-.42-7.677-.42s-6.142,0-7.677.4A2.508,2.508,0,0,0,.4-3.932,25.9,25.9,0,0,0,0,.787,25.806,25.806,0,0,0,.4,5.506,2.458,2.458,0,0,0,2.134,7.236c1.551.42,7.677.42,7.677.42s6.142,0,7.677-.4a2.458,2.458,0,0,0,1.73-1.729A25.909,25.909,0,0,0,19.622.8a24.587,24.587,0,0,0-.4-4.735ZM7.856,3.728V-2.155L12.963.787Zm0,0",
  transform: "translate(-0.001 6.082)"
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.621,
    height: 13.738,
    viewBox: "0 0 19.621 13.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ca9c1bd8.svg";
export { ForwardRef as ReactComponent };